import { Medialink } from '../../../../api/medialink';
import { SharedSlideSet, SlideSet } from '../../../../api/slide-set';
import { UserMaterial } from '../../../../api/user-material';

export function flattenMaterial<T extends Medialink | UserMaterial | (SlideSet | SharedSlideSet)>(
  materialArray: { data: T[]; total: number }[],
): { data: T[]; total: number } {
  return {
    data: materialArray.flatMap(x => x.data),
    total: materialArray.reduce((sum, x) => sum + x.total, 0),
  };
}

export function orderByReference<T extends string>(reference: T[], subset: T[]): T[] {
  const indexMap = new Map(reference.map((item, index) => [item, index]));

  return subset.slice().sort((a, b) => {
    return (indexMap.get(a) ?? 0) - (indexMap.get(b) ?? 0);
  });
}
